import type { ReactNode } from "react";
import { type ExternalToast, toast } from "sonner";
import { notify } from "@/analytics/notify";

type Level = "success" | "error" | "warning" | "info";

const show =
  (level: Level) =>
  (toastKey: string, message: ReactNode, options?: ExternalToast): string | number => {
    notify("toast.shown", { level, toastKey });
    return toast[level](message, options);
  };

export const showToast = {
  success: show("success"),
  error: show("error"),
  warning: show("warning"),
  info: show("info"),
  dismiss: (id?: string | number) => toast.dismiss(id),
};
